var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable } from 'mobx';
import CustomGradingAPI from '../api/CustomGradingAPI';
import GradeAttribute from '../entity/GradeAttribute';
export default class CustomGradeAttributeStore {
    attributes = {};
    promises = {};
    customGradingAPI;
    constructor() {
        this.customGradingAPI = new CustomGradingAPI();
    }
    fetchItem = (customGradeCode) => {
        if (this.promises[customGradeCode]) {
            return this.promises[customGradeCode];
        }
        this.promises[customGradeCode] = this.customGradingAPI.fetchCustomGradeAttribute(customGradeCode).then(action((res) => {
            const gradeAttribute = new GradeAttribute({ ...res.content, code: customGradeCode });
            this.attributes[customGradeCode] = gradeAttribute;
            return gradeAttribute;
        }));
        return this.promises[customGradeCode];
    };
}
__decorate([
    observable
], CustomGradeAttributeStore.prototype, "attributes", void 0);
__decorate([
    observable
], CustomGradeAttributeStore.prototype, "promises", void 0);
// TODO move
export const customGradeAttributeStore = new CustomGradeAttributeStore();
